<template>
    <div class="page-cabinet-referral-info-list-cards">
        <div class="page-cabinet-referral-info-list-cards__item"
            v-for="(item, index) in items"
            v-bind:key="index"
            >
            <ui-card-base>
                <div class="page-cabinet-referral-info-list-cards__item-status">
                    <page-cabinet-referral-info-list-status v-bind:code="item.status" />
                    <page-cabinet-referral-info-list-payment-status v-bind:code="item.paymentStatus" />
                </div>
                <div class="page-cabinet-referral-info-list-cards__item-line"
                    v-for="(line, index) in item.lines"
                    v-bind:key="index"
                    >
                    <div class="page-cabinet-referral-info-list-cards__item-line-title"
                        v-text="line.title + ':'"
                    />
                    <div class="page-cabinet-referral-info-list-cards__item-line-value"
                        v-text="line.value"
                    />
                </div>
                <div class="page-cabinet-referral-info-list-cards__item-details"
                    v-if="item.details && item.details.length > 0"
                    v-bind:class="{ _expanded: isExpanded(index) }"
                    >
                    <div class="page-cabinet-referral-info-list-cards__item-details-trigger"
                        v-on:click="toggleDetails(index)"
                        >
                        <span class="page-cabinet-referral-info-list-cards__item-details-trigger-text"
                            v-text="'Детализация'"
                        />
                        <span class="page-cabinet-referral-info-list-cards__item-details-trigger-icon">
                            <icon name="triangle" />
                        </span>
                    </div>
                    <div class="page-cabinet-referral-info-list-cards__item-details-list"
                        v-if="isExpanded(index)"
                        >
                        <div class="page-cabinet-referral-info-list-cards__item-details-group"
                            v-for="(group, index) in item.details"
                            v-bind:key="index"
                            >
                            <div class="page-cabinet-referral-info-list-cards__item-line"
                                v-for="(line, index) in group.lines"
                                v-bind:key="index"
                                >
                                <div class="page-cabinet-referral-info-list-cards__item-line-title"
                                    v-text="line.title + ':'"
                                />
                                <div class="page-cabinet-referral-info-list-cards__item-line-value">
                                    <page-cabinet-referral-info-list-payment-status
                                        v-if="line.paymentStatus"
                                        v-bind:code="line.paymentStatus"
                                    />
                                    <span v-else
                                        v-text="line.value"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ui-card-base>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'page-cabinet-referral-info-list-cards',
    data: () => ({
        expandedItems: {},
    }),
    computed: {
        ...mapState('referral', [
            'getReferralsResult',
        ]),
        items() {
            return this.getReferralsResult.map(x => ({
                status: x.status,
                paymentStatus: x.paymentStatus,
                lines: [
                    { title: 'ФИО', value: x.name },
                    { title: 'Сумма инвестиции', value: x.investment > 0 ? x.investmentFormatted : '–' },
                    { title: 'Комиссия', value: x.investment > 0 ? x.feeFormatted : '–' },
                ],
                details: this.getDetailsData(x.investments),
            }));
        },
    },
    methods: {
        isExpanded(index) {
            return !!this.expandedItems[index];
        },
        toggleDetails(index) {
            this.$set(this.expandedItems, index, !this.expandedItems[index]);
        },
        getDetailsData(investments) {
            if (investments.length > 0) {
                return investments.map(x => ({
                    lines: [
                        { title: 'Сумма инвестиции', value: x.investmentFormatted },
                        { title: 'Ставка', value: x.commissionPercentFormatted },
                        { title: 'Комиссия', value: x.commissionFormatted },
                        // { title: 'Выплата', paymentStatus: x.paymentStatus },
                    ],
                }));
            }
            return null;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-referral-info-list-cards {
    &__item {
        & ~ & {
            margin-top: 8px;
        }
        &-status {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 24px;
        }
        &-line {
            & ~ & {
                margin-top: 4px;
            }
            &-title {
                .typography-caption();

                display: inline-block;
                margin-right: 12px;

                color: @color-gray-main;
                font-weight: bold;
                text-transform: uppercase;
            }
            &-value {
                .typography-body();

                display: inline-block;
                vertical-align: middle;
            }
        }
        &-details {
            padding: 16px;
            border-radius: @border-radius-lg;
            margin-top: 16px;

            background-color: @color-gray-lighter;
            &-trigger {
                .typography-caption();

                display: inline-flex;
                justify-content: flex-start;
                align-items: center;

                color: @color-primary;
                font-weight: bold;
                text-transform: uppercase;

                user-select: none;
                cursor: pointer;

                transition: color @duration-faster ease-in-out;
                &:hover {
                    color: @color-primary-3;
                }
                &-icon {
                    display: flex;
                    margin-left: 6px;

                    font-size: 1.8rem;

                    transform: rotate(180deg);

                    transition: transform @duration-faster ease-in-out;
                }
            }
            &._expanded &-trigger-icon {
                transform: rotate(0);
            }
            &-group {
                padding-top: 16px;
                margin-top: 16px;
                border-top: 1px solid @color-gray-light;
            }
        }
    }
}
</style>
